import React from 'react'
import Header from '../Components/Header/Header.js'
import UserSearch from '../Components/UserSearch/UserSearch.js'

function UserSearchPage() {
  return (
    <div>
        <Header/>
        <UserSearch/>
    </div>
  )
}

export default UserSearchPage